import Accordion from "react-bootstrap/Accordion";
import * as React from 'react';
export default {
  Accordion,
  React
};